import { zipWith, compact, trim } from 'lodash-es'

export default {
  props: ['headings', 'contents', 'sizeChart'],
  delimiters: ['#{', '}'],
  data() {
    return {
      items: []
    };
  },
  template: `
    <div class="pdp-details border-t border-black/50">
      <div v-for="item, i in items" class="border-b border-black/50">
        <h3 class="cursor-pointer py-3 pr-2 flex justify-between" @click="toggleSlide(item)">
          <span class="uppercase">#{ item.heading }</span>
          <span :class="{ 'icon-plus': !item.expanded, 'icon-minus': item.expanded }"></span>
        </h3>

        <div class="pdp-details__content-wrapper overflow-hidden max-h-0 transition-max-h duration-300"
          ref="contentWrapper">
          <div class="pdp-details__content pt-4 pb-5 border-t border-black/15" ref="content">
            <p v-html="item.content"></p>
          </div>
        </div>

      </div>
    </div>
  `,
  created() {
    this.items = compact(
      zipWith(this.headings, this.contents, function(heading, content) {
        heading = trim(heading)
        content = trim(content.replaceAll('\n', '<br/>'))
        if (heading.length > 0 && content.length > 0) return {
          heading,
          content,
          expanded: false
        }
      })
    )
    if (this.sizeChart && this.sizeChart.length) {
      this.items.push( {
        heading: 'Size Chart',
        content: this.sizeChart,
        expanded: false
      })
    }
  },
  methods: {
    toggleSlide(selectedItem) {
      if (selectedItem.expanded) {
        this.slideUp(selectedItem)
      } else {
        this.slideDown(selectedItem)
      }
    },

    slideDown(selectedItem) {
      const i = this.items.indexOf(selectedItem)

      this.items.forEach((item, j) => {
        if (i !== j && item.expanded) {
          this.slideUp(item)
        }
      })

      const content = this.$refs.content[i]
      const contentWrapper = this.$refs.contentWrapper[i]
      contentWrapper.setAttribute('style', `max-height: ${content.scrollHeight}px`)
      selectedItem.expanded = true

    },

    slideUp(selectedItem) {
      const i = this.items.indexOf(selectedItem)
      const content = this.$refs.content[i]
      selectedItem.expanded = false

      const contentWrapper = this.$refs.contentWrapper[i]
      contentWrapper.setAttribute('style', `max-height: 0`)
    }

  }
}
